module.exports = __webpack_public_path__ + "img/like-active.2fc48d9e.svg";